<template>
  <div class="as-tab-data">
    <h2>Dữ liệu đội bóng</h2>
    <h2 class="as-active">{{ match.home_team.name }} vs {{ match.away_team.name }}</h2>
    <div class="as-tab-data__header">
      <div>Đội nhà</div>
      <div>3 trận gần nhất</div>
      <div>Đội khách</div>
    </div>
    <div class="as-tab-data__content">
      <div class="as-tab-data__content-item">
        <div>33</div>
        <div>Ghi bàn</div>
        <div>44</div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { IMatch } from "~src/interfaces";

interface IProps {
  match: IMatch;
}

const props = withDefaults(defineProps<IProps>(), {});
</script>

<script lang="ts">
export default {};
</script>
